class FooterItems extends HTMLElement {
  constructor() {
    super();
    this.footerNewsletter = this.querySelector(".footer-column-newsletter");
    this.footerColumns = this.querySelector(".footer-columns");

    if (this.footerNewsletter) {
      this.phoneInput();
    }

    if (this.footerColumns) {
      this.footerColumns.addEventListener("click", this.onMenuClick.bind(this));
    }
  }

  phoneInput() {
    const countrySelect = document.getElementById("country-select");
    const phoneInput = document.getElementsByClassName("phone-label")[0];
    const form = document.getElementById("ContactFooter");

    countrySelect?.addEventListener("change", () => {
      const country = countrySelect.value;

      const usFlag = document.querySelector(".us-flag");
      const caFlag = document.querySelector(".ca-flag");

      if (country === "us") {
        usFlag.classList.remove("hide");
        caFlag.classList.add("hide");
      } else if (country === "ca") {
        usFlag.classList.add("hide");
        caFlag.classList.remove("hide");
      }
    });

    // Validation of the form
    form?.addEventListener("submit", (event) => {
      const phoneValue = phoneInput.value;

      // If the field is not empty, validate the pattern
      if (phoneValue && !new RegExp(phoneInput.pattern).test(phoneValue)) {
        // If the field does not match the pattern, cancel the form submission
        event.preventDefault();
      }
    });
  }

  onMenuClick(event) {
    const clickedInsideLevel2 = event.target.closest(".footer-submenu-level2");
    if (clickedInsideLevel2) {
      return;
    }

    // Management of first-level item activation
    const menuItem = event.target.closest(".footer-menu-item");
    if (menuItem && !event.target.closest(".footer-submenu")) {
      // If the click is on a footer-menu-item but not in a submenu
      event.preventDefault(); // Prevent navigation if it's a link

      // Toggle active state for first-level item (no need to close other items)
      menuItem.classList.toggle("active");

      // Get all footer-menu-item elements
      const allMenuItems = document.querySelectorAll(".footer-menu-item");

      // Check if at least one menu item has the 'active' class
      const isAnyMenuActive = Array.from(allMenuItems).some((item) =>
        item.classList.contains("active"),
      );

      // Get all elements with the .pro-icon class
      const proIcons = document.querySelectorAll(".pro-icon");

      // If any menu is active, hide the icons, otherwise show them
      if (isAnyMenuActive) {
        proIcons.forEach((icon) => icon.classList.add("hide"));
      } else {
        proIcons.forEach((icon) => icon.classList.remove("hide"));
      }
    }

    // Check if the clicked item is a sub-item with a level 2 submenu
    const submenuItem = event.target.closest(".footer-submenu-item");
    if (submenuItem && submenuItem.classList.contains("has-submenu")) {
      event.preventDefault(); // Prevent navigation if it's a link

      // Toggle display of the level 2 submenu
      const level2Submenu = submenuItem.querySelector(".footer-submenu-level2");
      if (level2Submenu) {
        const isActive = level2Submenu.classList.toggle("active");

        // Add or remove the `submenu-open` class from the parent based on active state
        if (isActive) {
          submenuItem.classList.add("submenu-open");
        } else {
          submenuItem.classList.remove("submenu-open");
        }
      }
    }
  }

  // Closes all other top level items in mobile
  closeOtherMenuItems(currentItem) {
    const allMenuItems =
      this.footerColumns.querySelectorAll(".footer-menu-item");
    allMenuItems.forEach((item) => {
      if (item !== currentItem) {
        item.classList.remove("active");
      }
    });
  }
}

customElements.get("footer-items") ||
  customElements.define("footer-items", FooterItems);
